export default __webpack_public_path__ + "check127551.svg";